function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53 0C23.7758 0 0 23.7758 0 53C0 82.2242 23.7758 106 53 106C82.2242 106 106 82.2242 106 53C106 23.7758 82.2245 0 53 0ZM53 100.27C40.0159 100.27 28.239 95.0074 19.6873 86.5043C16.2723 83.1087 13.3734 79.1952 11.1162 74.8943C7.67866 68.3448 5.72981 60.896 5.72981 53C5.72981 26.9351 26.9351 5.72981 53 5.72981C65.3631 5.72981 76.6308 10.5027 85.0629 18.3003C89.4348 22.3427 93.0449 27.1972 95.648 32.6234C98.6096 38.7969 100.27 45.7081 100.27 53C100.27 79.0649 79.0649 100.27 53 100.27Z",
  fill: "#1ECD96"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8837 40.9681C37.9634 40.9681 40.4691 43.3306 40.4691 46.5536H46.1989C46.1989 40.1075 41.1231 35.2383 34.8837 35.2383C28.6443 35.2383 23.5684 40.1075 23.5684 46.5536H29.2982C29.2982 43.3306 31.8042 40.9681 34.8837 40.9681Z",
  fill: "#1ECD96"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M71.1151 40.9681C74.1949 40.9681 76.7006 43.3306 76.7006 46.5536H82.4304C82.4304 40.1075 77.3545 35.2383 71.1151 35.2383C64.8757 35.2383 59.7998 40.1075 59.7998 46.5536H65.5296C65.5296 43.3306 68.0353 40.9681 71.1151 40.9681Z",
  fill: "#1ECD96"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.8989 82.3639C63.9839 82.3639 74.6073 76.695 80.6898 67.2827L75.8772 64.1729C70.292 72.8159 60.0722 77.6397 49.8449 76.459C41.8726 75.5397 34.5001 70.9466 30.1229 64.1729L25.3105 67.2827C30.607 75.4795 39.5334 81.0374 49.1881 82.1508C50.4275 82.2941 51.6652 82.3639 52.8989 82.3639Z",
  fill: "#1ECD96"
});

var SvgUserSmile = function SvgUserSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_smile.5d4fc74b.svg";
export { ForwardRef as ReactComponent };